import {Directive, forwardRef, inject, input} from '@angular/core';
import {AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors} from '@angular/forms';
import {map, Observable, of} from 'rxjs';
import {ManufacturerRest} from '../../service/ManufacturerRest';

@Directive({
  selector: '[existJuristicId]',
  standalone: true,
  providers: [{provide: NG_ASYNC_VALIDATORS, useExisting: forwardRef(() => ExistJuristicId), multi: true}]
})
export class ExistJuristicId implements AsyncValidator {
  manufacturerRest = inject(ManufacturerRest)
  itemId = input.required<number>()

  validate(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    if (!control.value) {
      return of(null);
    }
    return this.manufacturerRest.existJuristicId(control.value.trim(), this.itemId()).pipe(map(e => {
      if (!e) {
        return null
      } else {
        return {exists: 'exists'}
      }
    }))
  }
}
